import { defineMessages } from '@jutro/locale';

export default defineMessages({
    whatTypeOfAddressChange: {
        id: 'ml.gateway.MLAddressChangeTypePopup.What type of address change',
        defaultMessage: 'What type of address change?'
    },
    startNewQuoteForNewProperty: {
        id: 'ml.gateway.MLAddressChangeTypePopup.Please START A NEW QUOTE for the new property',
        defaultMessage: 'Please {strongSpan} for the new property'
    },
    startNewQuote: {
        id: 'ml.gateway.MLAddressChangeTypePopup.START A NEW QUOTE',
        defaultMessage: 'START A NEW QUOTE'
    },
    contactYourAgentOrCallUs: {
        id: 'ml.gateway.MLAddressChangeTypePopup.contact your agent or call us',
        defaultMessage: 'To change your address, contact your agent or call us at 1-800-422-4272 or click on {strongSpan}.'
    },
    cancel: {
        id: 'ml.gateway.MLAddressChangeTypePopup.CANCEL',
        defaultMessage: 'CANCEL'
    }
});
